import { combineEpics } from 'redux-observable'

import ctaPromptEpics from '../ctaPrompt/ctaPromptEpics'
import stopDrawerEpics from '../stopselector/stopDrawerEpics'
import actionButtonEpics from '../action-buttons/actionButtonEpics'
import interactiveElementsEpics from '../interactive-element/epics'
import registrationEpics from 'aria-viewer/registration/epics'
import playersEpics from 'aria-viewer/players/epics'
import mediaEpics from 'aria-viewer/media/epics'
import deviceEpics from 'aria-viewer/device/epics'
import analyticEpics from 'aria-viewer/analytics/epics'
import tourEpics from 'aria-viewer/tour/epics'

const rootEpic = combineEpics(
    ctaPromptEpics,
    stopDrawerEpics,
    actionButtonEpics,
    interactiveElementsEpics,
    registrationEpics,
    playersEpics,
    mediaEpics,
    deviceEpics,
    analyticEpics,
    tourEpics
)

export default rootEpic
